import styled from "@emotion/styled"
import bgSplash from "../../images/bg-splash.png"

const SectionBackground = styled.section`
  background-repeat: no-repeat;
  background-position: ${props =>
      props.bgPosition === "right" ? "140%" : "-80%"}
    top;
  background-size: ${props =>
    props.bgPosition === "right" ? "800px" : "1000px"};
  background-image: url(${bgSplash});
  margin-bottom: 60px;
`

export { SectionBackground }
